import { render, staticRenderFns } from "./footerElement.vue?vue&type=template&id=b1465910"
import script from "./footerElement.vue?vue&type=script&lang=js"
export * from "./footerElement.vue?vue&type=script&lang=js"
import style0 from "./footerElement.vue?vue&type=style&index=0&id=b1465910&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports